import { IonText } from '@ionic/react';
import styled from 'styled-components';
import { layout, space, typography, } from 'styled-system';
import { transient } from '../../../utils';
const GrapeText = styled(IonText) `
  ${transient(layout)}
  ${transient(space)}
  ${transient(typography)}
`;
export { GrapeText };
//# sourceMappingURL=index.js.map